import {MapService} from './map';
import {PlatformService} from './platform';
import {SessionService} from './session';
import {BackendModule} from '../modules/backend.module';
import {Injectable} from '@angular/core';
import {VersionService} from './version';
import {Storage} from '@ionic/storage';

const uuid = 'fitpass.uuid';

@Injectable()
export class AnalyticsService {

  deviceID: string = null;

  constructor(
    public sessionService: SessionService,
    public backendModule: BackendModule,
    public mapService: MapService,
    public platformService: PlatformService,
    public versionService: VersionService,
    private storage: Storage,
  ) {
    const gtag = window['gtag'];
    const clientId = localStorage.getItem('ga:clientId');
    if (clientId) {
      gtag('set', 'client_id', clientId);
    } else {
      gtag('get', 'G-2LMBSMHV8G', 'client_id', (client_id) => {
        // Save the assigned id for the next time the app boots.
        localStorage.setItem('ga:clientId', client_id);
      });
    }
  }

  trackEvent(category, action, label?, value?) {
    const gtag = window['gtag'];
    value = value || 1;

    gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value
    });
  }

  // Yes, I could have subscribed to events to do this, but it would
  // have meant adding event pub/sub in lots of places. This is simpler.
  trackActivity() {
    const TRACK_INTERVAL_IN_SECONDS = 0.5;
    let previousPage = null;

    setInterval(() => {
      let currentPage = window['page'],
        ga = window['ga'];

      if (previousPage !== currentPage) {
        previousPage = currentPage;
        ga('send', 'pageview', currentPage);
      }
    }, TRACK_INTERVAL_IN_SECONDS * 1000);
  }

  getDeviceId = () => {
    this.storage.get(uuid)
      .then((uuid: any) => {
        if (uuid) {
          this.deviceID = uuid.uuid;
        } else {
          var id = new Date().getTime().toString()
          this.storage.set(uuid, id);
          this.deviceID = id;
        }
      })
      .catch((error: any) =>
        alert(error)
      );
  }

  ping(callback) {
    const PING_INTERVAL_IN_SECONDS = 60;

    // Regularly ping the server with user session info
    setInterval(() => {
      if (this.sessionService.user) {
        let sessionUser = this.sessionService.user,
          appPlatform = this.platformService.platform;

        this.backendModule
          .putAPI(`users/${sessionUser.id}/ping`, {
            user: {
              email: sessionUser.email,
              platform: appPlatform,
              deviceID: this.deviceID
            },
            location: {
              lat: this.mapService.myLocation.lat.toString(),
              lng: this.mapService.myLocation.lng.toString()
            },
            version: this.versionService.appVersion
          })
          .subscribe(
            (responseUser: any) => {
              this.trackEvent(appPlatform, 'ping', sessionUser.id);
              if (callback && responseUser) {
                callback(responseUser);
              }
            },
            err => {
              this.sessionService.reportError(
                'analyticsService',
                'ping()',
                err
              );
            }
          );
      }
    }, PING_INTERVAL_IN_SECONDS * 1000);
  }
}



// WEBPACK FOOTER //
// ./src/services/analytics.ts